import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  createUserApiKey,
  deleteUserApiKey,
  disableUserApiKey,
  enableUserApiKey,
  getUserApiKeys,
} from '@lib/api'
import { apiKeyKeys } from '@lib/keys'

export const useApiKeys = (userId: number) => {
  return useQuery(apiKeyKeys.forUser(userId), () => getUserApiKeys(userId))
}

export const useCreateApiKey = (userId: number) => {
  const queryClient = useQueryClient()

  return useMutation(() => createUserApiKey(userId), {
    onSuccess: () => {
      void queryClient.invalidateQueries(apiKeyKeys.forUser(userId))
    },
  })
}

export const useDeleteApiKey = (userId: number) => {
  const queryClient = useQueryClient()

  return useMutation((apiKeyId: number) => deleteUserApiKey(userId, apiKeyId), {
    onSuccess: () => {
      void queryClient.invalidateQueries(apiKeyKeys.forUser(userId))
    },
  })
}

export const useEnableApiKey = (userId: number) => {
  const queryClient = useQueryClient()

  return useMutation((apiKeyId: number) => enableUserApiKey(userId, apiKeyId), {
    onSuccess: () => {
      void queryClient.invalidateQueries(apiKeyKeys.forUser(userId))
    },
  })
}

export const useDisableApiKey = (userId: number) => {
  const queryClient = useQueryClient()

  return useMutation(
    (apiKeyId: number) => disableUserApiKey(userId, apiKeyId),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(apiKeyKeys.forUser(userId))
      },
    },
  )
}

